import React from 'react';
import PropTypes from 'prop-types';
import { RecommendationModal } from './modal';
import { AsyncApplyForm } from './forms/async-apply-form';

export class AsyncApplyFormModal extends React.PureComponent {
  static propTypes = {
    i18n: PropTypes.shape({
      getString: PropTypes.func.isRequired,
    }).isRequired,
    isAsyncApplyModalOpen: PropTypes.bool.isRequired,
    closeAsyncApplyModal: PropTypes.func.isRequired,
    viewHistory: PropTypes.func.isRequired,
  };

  render() {
    const {
      i18n,
      isAsyncApplyModalOpen,
      closeAsyncApplyModal,
      viewHistory,
    } = this.props;

    return (
      <RecommendationModal
        isOpen={isAsyncApplyModalOpen}
        onCancel={closeAsyncApplyModal}
      >
        <AsyncApplyForm
          i18n={i18n}
          runInBackground={closeAsyncApplyModal}
          routeApplyHistory={() => {
            closeAsyncApplyModal();
            viewHistory();
          }}
        />
      </RecommendationModal>
    );
  }
}
